import { requestConstants } from '../constants/request.constants';

export function getStatusLabel(status) {
    switch(status) {
        case requestConstants.STATUS_CREATED: return "Pendente";
        case requestConstants.STATUS_APPROVED: return "Aprovada";
        case requestConstants.STATUS_REJECTED: return "Rejeitada";
        case requestConstants.STATUS_EXPIRED: return "Expirada";
        default: return "";
    }
}

export function getTypeLabel(status) {
    switch(status) {
        case requestConstants.TYPE_ADDITIONAL: return "Tempo Adicional";
        case requestConstants.TYPE_FULLDAY: return "Dia Inteiro";
        case requestConstants.TYPE_SCHEDULED: return "Horário Agendado";
        case requestConstants.TYPE_START: return "Início de Jornada";
        case requestConstants.TYPE_UNLOCK: return "Desbloqueio";
        default: return "";
    }
}

export function getStatusColor(status) {
    switch(status) {
        case requestConstants.STATUS_CREATED: return null;
        case requestConstants.STATUS_APPROVED: return "green";
        case requestConstants.STATUS_REJECTED: return "red";
        case requestConstants.STATUS_EXPIRED: return "black";
        default: return "";
    }
}